


export default {
    head() {
        return {
            title: this.pageTitle,
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: this.pageDescription
                },
                {
                    hid: 'twitter:title',
                    name: 'twitter:title',
                    content: this.pageOGTitle
                },
                {
                    hid: 'twitter:description',
                    name: 'twitter:description',
                    content: this.pageDescription
                },
                {
                    hid: 'twitter:image',
                    name: 'twitter:image',
                    content: this.coverURL
                },
                {
                    hid: 'twitter:image:alt',
                    name: 'twitter:image:alt',
                    content: this.coverTitle
                },
                {
                    hid: 'og:title',
                    property: 'og:title',
                    content: this.pageOGTitle
                },
                {
                    hid: 'og:description',
                    property: 'og:description',
                    content: this.pageDescription
                },
                {
                    hid: 'og:image',
                    property: 'og:image',
                    content: this.coverURL
                },
                {
                    hid: 'og:image:secure_url',
                    property: 'og:image:secure_url',
                    content: this.coverURL
                },
                {
                    hid: 'og:image:alt',
                    property: 'og:image:alt',
                    content: this.coverTitle
                }
            ]
        }
    },

    props: {
        city: Object,
        isFavorited: Boolean
    },

    data() {
        return {

            creditVisible: false,

            // Titre de la page
            pageTitle: `Vivre à ${this.city.full_name} (${this.city.region.fr_code_dep}) : avis et informations - ${this.$config.siteTitle}`,

            // Titre open graph et twitter de la page
            pageOGTitle:
                `Vivre à ${this.city.full_name} (${this.city.region.fr_code_dep} - ${this.city.region.name}) `
                + `- Tous les chiffres et avis sur cette commune.`,

            // Description de la page (SEO twitter et open graph)
            pageDescription: `Tous les chiffres et avis sur ${this.city.full_name} (${this.city.region.fr_code_dep} - ${this.city.region.name}).`
                + ` Population, immobilier, climat, sécurité, politique et économie. Evaluez cette commune.`,

            // URL top background (utilisé également pour open graph et twitter)
            coverURL: (this.city.cover_url == "") ? this.city.region.cover_url : this.city.cover_url,

            // Src Set
            coverSrcSet: (this.city.cover_srcset.length) ? this.city.cover_srcset[0] : this.city.region.cover_srcset[0],

            // infos crédits auteur image
            coverAuthor: (this.city.cover_infos)
                ? this.city.cover_infos.properties.credit_author
                : ((this.city.region.cover_infos) ? this.city.region.cover_infos.properties.credit_author : ''),

            // description de l'image
            coverTitle: (this.city.cover_infos)
                ? `Commune : ${this.city.full_name}`
                : ((this.city.region.cover_infos) ? `Département : ${this.city.region.name}` : '')
        }
    },

    methods: {
        set: function (creditVisible) {
            var self = this;
            this.creditVisible = !creditVisible;
            return this.$emit('update:credit-button', this.creditVisible);
        },
        favorite() {
            this.$emit("toogle-favorite");
        },

    }
}
